var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip",value:(_vm.tooltip),expression:"tooltip"}],attrs:{"aria-controls":"super-sidebar","aria-expanded":_vm.ariaExpanded,"aria-label":_vm.computedAriaLabel,"icon":_vm.icon,"data-testid":"super-sidebar-toggle-button","category":"tertiary"},on:{"click":_vm.toggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }